<template>
    <div class="dropzone-file-uploader">
        <div class="dropzone-file-uploader__files">
            <div v-for="file in files" :key="file.name">
                <dropzone-file :file="file"></dropzone-file>
            </div>

            <div v-if="!files.length">
                <div class="dropzone-file-uploader__no-files">
                    <img
                        src="/images/dropzone/upload.svg"
                        alt="Cloud with an arrow"
                    />
                </div>
            </div>
        </div>

        <div
            class="dropzone-file-uploader__instructions"
            v-show="files.length == 0"
        >
            <slot>{{ trans('dropzone.click-or-drop') }}</slot>
        </div>

        <div class="dropzone-file-uploader__buttons">
            <button
                type="button"
                class="btn btn--secondary"
                v-show="files.length == 0"
            >
                {{ trans('dropzone.upload') }}
            </button>

            <button
                type="button"
                class="btn btn--secondary"
                @click="resetFileUpload"
                v-show="files.length > 0"
            >
                {{ trans('dropzone.remove') }}
            </button>
        </div>

        <div
            :class="[
                'dropzone-file-uploader__highlight-overlay',
                {
                    'dropzone-file-uploader__highlight-overlay--visible': isHighlighted
                }
            ]"
            v-show="files.length == 0"
        >
            {{ trans('dropzone.drop-file-here') }}
        </div>

        <input
            type="file"
            :accept="accept"
            :multiple="multiple"
            :name="name"
            @change="handleFileUpload"
            :id="id"
            v-show="files.length == 0"
        />
    </div>
</template>

<script>
export default {
    data() {
        return {
            files: [],
            inputElement: null,
            highlightElement: null,
            isHighlighted: false
        };
    },
    props: {
        name: String,
        accept: {
            type: String,
            default: '.jpg,.jpeg,.png,.gif,.doc,.docx,.xls,.xlsx,.csv,.pdf,.css'
        },
        multiple: Boolean
    },
    computed: {
        id() {
            return this.name + '-id';
        }
    },
    methods: {
        handleFileUpload() {
            const files = this.inputElement.files;

            this.files.push(...files);
            this.$emit('change', this.files);
        },

        resetFileUpload() {
            this.inputElement.value = '';
            this.files = [];
            this.$emit('change', []);
        },

        addDragAndDropLogic() {
            this.inputElement.addEventListener(
                'dragenter',
                () => (this.isHighlighted = true),
                false
            );
            this.inputElement.addEventListener(
                'dragleave',
                () => (this.isHighlighted = false),
                false
            );
            this.inputElement.addEventListener(
                'drop',
                () => (this.isHighlighted = false),
                false
            );
        }
    },
    mounted() {
        this.inputElement = document.getElementById(this.id);
        this.highlightElement = this.$el.getElementsByClassName(
            'dropzone-file-uploader__highlight-overlay'
        )[0];

        this.addDragAndDropLogic();
    }
};
</script>
